var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('Card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v("فایلهای بارگذاری شده من")]),_c('hr')]},proxy:true},{key:"content",fn:function(){return [_c('EducationTable',{attrs:{"FromMyFiles":true,"tablename":_vm.File,"label":_vm.File}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }